/*
  Order rules and rewards for Alma Mate.
  - Minimum tins per order: blocks the checkout buttons below the minimum.
  - Free tin / mystery gift: $0 products that are added to the cart
    automatically at the configured tin counts and removed again if the
    shopper drops below them. Reward lines carry the hidden property
    _ama_reward so they are never counted as purchased tins.

  Note: the minimum is enforced in the storefront. A shopper who opens the
  checkout address directly can still bypass it (only a Shopify Function app
  can enforce it at checkout).
*/
(function () {
  var C = window.AMA_REWARDS || {};
  var busy = false;
  var again = false;
  var lastCart = null;

  // A reward line is either tagged with the hidden property or is one of the
  // reward products (so a $0 tin or gift added by hand never counts as a paid tin).
  function isReward(item) {
    if (item.properties && item.properties._ama_reward) return true;
    return (C.freeTinIds || []).indexOf(item.variant_id) !== -1 || (C.giftIds || []).indexOf(item.variant_id) !== -1;
  }
  function paidCount(cart) {
    var n = 0;
    cart.items.forEach(function (i) { if (!isReward(i)) n += i.quantity; });
    return n;
  }
  function availableFree() {
    return (C.freeTin || []).filter(function (v) { return v.available; });
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
      credentials: 'same-origin',
    }).then(function (r) { return r.json(); });
  }

  var Rewards = {
    config: C,
    paidCount: paidCount,
    hasFreeTin: function () { return availableFree().length > 0 && C.freeTinAt > 0; },
    hasGift: function () { return !!(C.gift && C.gift.id) && C.giftAt > 0; },
    freeVariants: availableFree,

    // Reward cart items for a purchase of `paidQty` tins.
    rewardItems: function (paidQty, flavorTitle) {
      var items = [];
      if (Rewards.hasFreeTin() && paidQty >= C.freeTinAt) {
        var list = availableFree();
        var v = list.filter(function (x) { return x.title === flavorTitle; })[0] || list[0];
        items.push({ id: v.id, quantity: 1, properties: { _ama_reward: 'free-tin' } });
      }
      if (Rewards.hasGift() && paidQty >= C.giftAt) {
        items.push({ id: C.gift.id, quantity: 1, properties: { _ama_reward: 'gift' } });
      }
      return items;
    },

    // Make the reward lines in the cart match the number of paid tins.
    reconcile: function (cart) {
      var paid = paidCount(cart);
      var updates = {};
      var adds = [];
      var freeIds = C.freeTinIds || [];
      var giftIds = C.giftIds || [];
      var free = cart.items.filter(function (i) { return i.properties && i.properties._ama_reward === 'free-tin' && freeIds.indexOf(i.variant_id) !== -1; });
      var gift = cart.items.filter(function (i) { return i.properties && i.properties._ama_reward === 'gift' && giftIds.indexOf(i.variant_id) !== -1; });
      // Reward products that were not added by the site (no tag) are removed;
      // the proper line is added below when the shopper has earned it.
      cart.items.forEach(function (i) {
        if (isReward(i) && free.indexOf(i) === -1 && gift.indexOf(i) === -1) updates[i.key] = 0;
      });
      var wantFree = Rewards.hasFreeTin() && paid >= C.freeTinAt;
      var wantGift = Rewards.hasGift() && paid >= C.giftAt;

      function settle(lines, want, makeAdd) {
        if (!want) { lines.forEach(function (l) { updates[l.key] = 0; }); return; }
        if (!lines.length) { adds.push(makeAdd()); return; }
        lines.forEach(function (l, i) { if (i > 0 || l.quantity !== 1) updates[l.key] = i === 0 ? 1 : 0; });
      }
      settle(free, wantFree, function () {
        var best = null;
        cart.items.forEach(function (i) { if (!isReward(i) && (!best || i.quantity > best.quantity)) best = i; });
        return Rewards.rewardItems(C.freeTinAt, best && best.variant_title)[0];
      });
      settle(gift, wantGift, function () {
        return { id: C.gift.id, quantity: 1, properties: { _ama_reward: 'gift' } };
      });

      var jobs = Promise.resolve(false);
      if (adds.length) jobs = jobs.then(function () { return post('/cart/add.js', { items: adds }); }).then(function () { return true; });
      if (Object.keys(updates).length) jobs = jobs.then(function () { return post('/cart/update.js', { updates: updates }); }).then(function () { return true; });
      return jobs;
    },

    // Disable checkout below the minimum and show the note.
    guard: function (cart) {
      lastCart = cart;
      var paid = paidCount(cart);
      var blocked = cart.items.length > 0 && paid < (C.minTins || 0);
      document.querySelectorAll('#checkout, button[name="checkout"], .cart__checkout-button').forEach(function (btn) {
        btn.disabled = blocked || (btn.id === 'checkout' && cart.items.length === 0);
        btn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      });
      // Express checkout (Shop Pay, PayPal, Google Pay) would skip the minimum.
      document.querySelectorAll('.additional-checkout-buttons, .cart__dynamic-checkout-buttons').forEach(function (el) {
        el.style.display = blocked ? 'none' : '';
      });
      document.querySelectorAll('[data-ama-min-note]').forEach(function (n) {
        var text = blocked ? 'Add ' + (C.minTins - paid) + ' more ' + (C.minTins - paid === 1 ? 'tin' : 'tins') + ' to check out.' : '';
        n.hidden = !blocked;
        if (n.textContent !== text) n.textContent = text;
      });
    },

    // Re-render the order-rules message (cart page, drawer, pop-up) from the live cart.
    refreshMessages: function () {
      var els = document.querySelectorAll('[data-ama-ship]');
      if (!els.length) return Promise.resolve();
      return fetch('/?sections=free-shipping-bar&t=' + Date.now(), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var doc = new DOMParser().parseFromString(data['free-shipping-bar'] || '', 'text/html');
          var fresh = doc.querySelector('[data-ama-ship]');
          if (!fresh) return;
          document.querySelectorAll('[data-ama-ship]').forEach(function (el) { el.replaceWith(fresh.cloneNode(true)); });
        })
        .catch(function () {});
    },

    sync: function () {
      // If a sync is already running, run once more when it finishes so a
      // cart change that happened in the meantime is never missed.
      if (busy) { again = true; return Promise.resolve(); }
      busy = true;
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          return Rewards.reconcile(cart).then(function (changed) {
            if (!changed) return cart;
            return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (fresh) {
              if (/^\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); }
              return fresh;
            });
          });
        })
        .then(function (cart) {
          Rewards.guard(cart);
          document.dispatchEvent(new CustomEvent('ama:cart-synced', { detail: cart }));
          return Rewards.refreshMessages();
        })
        .catch(function () {})
        .then(function () {
          busy = false;
          if (again) { again = false; Rewards.sync(); }
        });
    },
  };

  window.AmaRewards = Rewards;

  function init() {
    Rewards.sync();
    // PUB_SUB_EVENTS is a top-level const (not a window property), so read it by name.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { Rewards.sync(); });
    }
    // The cart footer is re-rendered after each change and comes back with an
    // enabled checkout button; re-apply the minimum right away.
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () { if (lastCart) Rewards.guard(lastCart); }, 30);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
